<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>

		<template v-slot:content>
			<pwa-apcn-content
				ref="content"
				:scrId="scrId"
				:pStartDt="pStartDt"
				:pEndDt="pEndDt"
				:pState1="pState1"
				:pState2="pState2"
				:pState3="pState3"
			/>
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/PwaApcn/store/helpers';
import PwaApcnContent from './Content/PwaApcnContent.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' } //클레임 승인현황에서 날짜 검색조건 가져옴
	},
	created() {
		console.clear();

		/*
		console.log('>>>>>>', screen.menuTitle);

		console.log('pStartDt >>>>>>', this.pStartDt);
		console.log('pEndDt >>>>>>', this.pEndDt);
		console.log('pState1 >>>>>>', this.pState1);
		console.log('pState2 >>>>>>', this.pState2);
		console.log('pState3 >>>>>>', this.pState3);
		*/

		//집입시 초기화
		this.setStateApcnInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		PwaApcnContent
	},
	data() {
		return {
			title: 'PWA 신청현황',
			favorite: true,
			screen: {}
			// locations: ['시스템관리', '다국어/메시지 관리']
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
